import axios from 'axios';
//Vue.prototype.$http = axios;

let hasCordova = true;
const isDebugMode = false;
import moment from 'moment';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

//const serverAPI = '/api/calculate';


let serverAPI = (window.HDAPI.serverurl) + '/api/calculate';

export default {
	debugMode() {
		return isDebugMode;
	},
	init() {

		//console.log("_packageVersion: " + PackageVersion)
		hasCordova = !!window.cordova;
		//console.log('plugin interface init: hasCordova:', hasCordova);

	},
	isRunningCordova() {
		const cordovaDefined = !!window.cordova;
		return cordovaDefined;
	},
	debugObject(_target) {
		var arr = [];
		for (var i in _target) {
			if (_target.hasOwnProperty(i)) {
				arr[i] = [_target[i]];
			}
		}
		console.table(arr);
	},
	coolMethod(str, success, error) {
		alert('coolMethod');
	},
	getUnitList(str, success, error) {
		alert('getUnitList');
	},
	calculate(obj, success, error) {
		if (!!window.cordova) {
			let jsonStr = JSON.stringify(obj, null, 2);
			cordova.plugins.hdcoolerslib.pl_calculate(jsonStr, success, error);

		} else {
			axios.post(serverAPI, obj)
				.then(resp => success(resp.data))
				.catch(err => error(err));
		}
	},
	openPDF(dd, unitname) {
		const filename = 'report_' + unitname + '_' + moment().format("YYYY-MM-DD");



		//debugbos
		if (!!window.cordova) {
			pdfMake.createPdf(dd).getBase64((base64encoded) => {
				cordova.plugins.email.open({
					subject: 'AtlasCopco HD coolers report',
					attachments: ['base64:' + filename + '.pdf//' + base64encoded]
				});
			});
		} else {
			pdfMake.createPdf(dd).download(filename + '.pdf'); // open();
			/*
			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(blob);
			} else {
				var objectUrl = URL.createObjectURL(blob);
				window.open(objectUrl);
			}
			*/
		}
	}
}


// WEBPACK FOOTER //
// ./src/plugin.api.js